import useTranslation from 'next-translate/useTranslation';
import React, { useState } from 'react';
import { Controller } from 'react-hook-form';
import { Errors } from './Errors';
import CreatableSelect from 'react-select/creatable';
import useManufacturers from '@/lib/hooks/fetchers/useManufacturers';

type Props = {
  name?: string;
  error: any;
  register: any;
  options?: any[];
  control: any;
  isMulti?: boolean;
  containerClasses?: string;
  label?: string;
};

const ManufacturerSelector = (props: Props) => {
  const [hideSelection, setHideSelection] = useState(false);
  const { t } = useTranslation();
  const { manufacturersOptions } = useManufacturers();
  const customStyles = {
    input: (provided: any) => ({
      ...provided,
      'input:focus': {
        boxShadow: 'none',
      },
    }),
    control: (provider: any) => ({
      ...provider,
      borderColor: props.error?.message !== undefined ? 'red' : '#6b7280',
      borderRadius: '0px',
      'control:focus': {
        borderColor: '#6b7280',
      },
    }),
    singleValue: (provided: any) => ({
      ...provided,
      display: hideSelection ? 'none' : 'block',
    }),
  };
  const options = props.options ?? manufacturersOptions;
  const optionsMap = options.map((o) => ({
    label: o.name,
    value: o.name,
  }));
  const name = props.name ?? 'manufacturer';

  return (
    <div className={props.containerClasses}>
      <label className='input-label' htmlFor={name}>
        {props.label} *
      </label>

      <Controller
        name={name}
        control={props.control}
        rules={{ required: t('common:Required') }}
        render={({ field }) => {
          return (
            <CreatableSelect
              {...field}
              options={optionsMap}
              styles={customStyles}
              placeholder=''
              formatCreateLabel={(s) => s}
              openMenuOnClick={false}
              id={name}
              value={optionsMap.find((c) => c.value === field.value)}
              onChange={(selected: any) => {
                field.onChange(selected?.value);
                setHideSelection(false);
                if (document.activeElement) {
                  (document.activeElement as HTMLElement).blur();
                }
              }}
              onFocus={() => {
                setHideSelection(true);
              }}
              onBlur={() => {
                setHideSelection(false);
              }}
            />
          );
        }}
      />

      <Errors data={props.error} />
    </div>
  );
};

export default ManufacturerSelector;
